import './choices_component.scss'
import { Controller } from 'stimulus'
import * as Choices from 'choices.js'

export default class extends Controller {
  static targets = ['select']

  initialize = (): void => {
    if (this.choices !== undefined) return
    this.choices = new Choices(this.selectTarget, {
      searchFields: ['label'],
      removeItemButton: true,
      itemSelectText: '↵ Enter to select',
      placeholder: true,
      classNames: {
        containerOuter: 'choices-input',
        containerInner: 'choices-input__inner',
        input: 'choices-input__input',
        inputCloned: 'choices-input__input--cloned',
        list: 'choices-input__list',
        listItems: 'choices-input__list--multiple',
        listSingle: 'choices-input__list--single',
        listDropdown: 'choices-input__list--dropdown',
        item: 'choices-input__item',
        itemSelectable: 'choices-input__item--selectable',
        itemDisabled: 'choices-input__item--disabled',
        itemOption: 'choices-input__item--choice',
        placeholder: 'choices__placeholder',
        group: 'choices-input__group',
        groupHeading: 'choices-input__heading',
        button: 'choices-input__button',
        activeState: 'is-active',
        focusState: 'is-focused',
        openState: 'is-open',
        disabledState: 'is-disabled',
        highlightedState: 'is-highlighted',
        selectedState: 'is-selected',
        flippedState: 'is-flipped'
      }
    })

    this.updateCount()
    const updateCount = this.updateCount

    this.element.addEventListener('addItem', function (event) {
      updateCount()
    })

    this.element.addEventListener('removeItem', function (event) {
      updateCount()
    })
  }

  updateCount = (): void => {
    const count: number = this.choices.getValue().length
    if (count === 0) {
      this.menuPanelController().deactivate()
    } else {
      this.menuPanelController().activate(count)
    }
  }

  focus = (): void => {
    this.choices.hideDropdown()
    this.choices.showDropdown()
  }

  menuPanelController = (): object => {
    return this.application.getControllerForElementAndIdentifier(this.element.parentNode.parentNode, 'menu-panel')
  }

  reset = (event: object): void => {
    this.choices.removeActiveItems()
    this.navigationController.clearQueryParams()
  }

  get navigationController (): object {
    return this.application.getControllerForElementAndIdentifier(this.element.closest('.navigation'), 'navigation')
  }

  submitForm = (event): void => {
    event.preventDefault()
    this.navigationController.submitForm()
  }
}
